import { connect } from 'react-redux'
import * as actions from '../../routes/Room/actions'
import SeminarTabs from './Seminars'

const mapStateToProps = (state, ownProps) => {
  return {
    isFetchingRooms: state.rooms.isFetchingRooms,
    isFetchingPreviousRooms: state.rooms.isFetchingPreviousRooms,
    upCommingRooms: state.rooms.upCommingRooms,
    previousRooms: state.rooms.previousRooms,
    selectConferenceId: state.rooms.selectConferenceId,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  fetchUpcomingSeminarRooms: (token, guest, firstTime) =>
    dispatch(actions.fetchUpcomingSeminarRooms(token, guest, firstTime)),
  selectConference: (conferenceId, token) =>
    dispatch(actions.selectConference(conferenceId, token)),
  fetchConferenceDetails: (token, conferenceId, guest) =>
    dispatch(actions.fetchConferenceDetails(token, conferenceId, guest)),
  fetchPreviousSeminarRooms: (token, guest) =>
    dispatch(actions.fetchPreviousSeminarRooms(token, guest))
})

const SeminarContainer = connect(mapStateToProps, mapDispatchToProps)(
  SeminarTabs
)

export default SeminarContainer



// WEBPACK FOOTER //
// ./src/components/Seminars/SeminarsContainer.js